<template>
  <header>
    <div class="left_area">
      <router-link :to="'/general/home'">
        <h1>
          <span>
              <button class="btn-home"><!--한화생명--></button>
          </span>
          <span>{{ $i18nUtil.trans("title.cowork", "업무공유시스템") }}</span>
        </h1>
      </router-link>
      <!--dl class="dl_layer select_ty3 scroll">
        <dt>
          <button type="button" @click="$event.target.parentElement.classList.toggle('active');">한화생명</button>
        </dt>
        <dd style="width:241px">
            <ul>
                <li><button type="button" class="ell-singleline">한화생명</button></li>
                <li><button type="button" class="ell-singleline">한화손해보험</button></li>
                <li><button type="button" class="ell-singleline">한화투자증권</button></li>
                <li><button type="button" class="ell-singleline">한화자산운용</button></li>
            </ul>
        </dd>
      </dl-->
    </div>
    <div class="right_area">
      <div class="header-search" v-if="isInternalUser === true && accessType === 'IN' && unifiedSearchUse">
        <div class="input-box">
          <input type="text"
            v-model="unifiedSearchKeyword"
            :placeholder='$i18nUtil.trans("message.MainHeader.003","과제, 성과, 보드, 파일을 검색하세요.")'
            @keyup.enter="openUnifiedSearch();" />
          <button type="reset" class="input-txt-del" @click="resetUnifiedSearchKeyword();">입력 삭제</button>
          <button type="reset" class="btn_search" @click="openUnifiedSearch();">검색</button>
        </div>
      </div>
      <ul class="header-util-text clear">
          <li><!--button type="button">사원찾기</button--></li>
          <li><!--button type="button">알림 <span class="ico-new"></span></button--></li>
      </ul>
      <span class="dividing_line_ty4" v-if="isInternalUser === true && accessType === 'IN' && unifiedSearchUse"></span>  
      <div class="user">
        <div class="name">
          {{ $i18nUtil.trans("message.userName","{user} 님", {user: userName}) }} <span>{{ deptName }}</span>
        </div>
        <button type="button" class="" @click="handleLogout">{{ $i18nUtil.trans("button.logout","로그아웃") }}</button>
      </div>
      <div class="util">
        <div class="droplayer icon setting large right nosel">
            <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">설정</v-btn>
                </template>
                <div class="dropdown-list">
                    <div class="dropdown-list-item">
                      <div class="tit">
                        <router-link :to="'/general/myInfo'">
                          <button type="button">{{ $i18nUtil.trans("title.MyInfo.001","내 정보 관리") }}</button>
                        </router-link>
                      </div>
                    </div>
                    <div class="dropdown-list-item">
                      <div class="tit">
                        <router-link :to="'/general/notiSetting'">
                          <button type="button">{{ $i18nUtil.trans("title.ModifyNotiSetting.001","알림 설정") }}</button>
                        </router-link> 
                      </div>
                    </div>
                    <div class="dropdown-list-item" v-if="i18nUse == 'true'">
                      <div class="tit">
                        <router-link :to="'/general/languageSetting'">
                          <button type="button">{{ $i18nUtil.trans("title.LanguageSetting.001","다국어 설정") }}</button>
                        </router-link>
                      </div>
                    </div>
                </div>
            </v-menu>
        </div>
        <!-- <dl class="dl_layer list right">
          <dt>
            <button type="button" class="setting" @click="$event.target.parentElement.classList.toggle('active');">설정</button>
          </dt>
          <dd style="width: 250px;">
            <div class="my-info">
              <div class="tit">
              </div>
              <div class="name">{{ userName }}</div>
              <div class="mail"></div>
              <div class="team">
                <span>한화생명</span>
                <span>DX전략팀</span>
              </div>
            </div>
            <ul>
              <li><button type="button">내 정보 관리</button></li>
              <li><button type="button" @click="modifyNotiSetting">알림 설정</button></li>
              <li><button type="button">다국어 설정</button></li>
            </ul>
          </dd>
        </dl>
        <dl class="dl_layer list right">
          <dt><button type="button" class="info" @click="$event.target.parentElement.classList.toggle('active');">정보</button></dt>
          <dd style="width: 126px;">
              <ul>
                  <li><button type="button">FAQ</button></li>
                  <li><button type="button">1:1문의</button></li>
                  <li><button type="button">협업시스템 사용법</button></li>
              </ul>
          </dd>
        </dl> -->
      </div>
    </div>
  </header>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
//import HeaderNoti from "./modal/Noti"
import ModifyPassword from "./modal/ModifyPassword";
import ModifyNotiSetting from "./modal/ModifyNotiSetting";
export default {
  components: {
    //HeaderNoti,
    ModifyPassword,
    ModifyNotiSetting
  },
  data() {
    return {
      i18nUse: localStorage.getItem('i18nUse') || 'false',
      isManager : null,
      accessType : null,
      show1: false,
      show2: false,
      show3: false,
      //알림
      show4: false,
      userName: null,
      deptName: null,
      inOut: null,
      req: {
        userId: null,
        password: null
      },
      toDoModal: false,
      CallModal: false,
      unifiedSearchKeyword: '',
      unifiedSearchUse:false,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },      
    };
  },
  created() {
    this.getLoggedUserInfo();
    this.checkUnifiedSearchUse();
  },
  computed : {
    ...mapState("introInfo", ["isInternalUser"]),
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast"]),

    ...mapMutations("mySocket", ["setSocketConnect","setSocketDisConnect"]),
    /* 로그인 사용자 정보 */
    getLoggedUserInfo() {
      let inOutKbn = localStorage.getItem("inOutKbn");
      this.accessType = localStorage.getItem("accessType");
      if (inOutKbn === "IN") {
        this.inOut = "내부망 사용자";
      } else {
        this.inOut = "외부망 사용자";
      }
      this.userName = localStorage.getItem("userName");
      this.deptName = localStorage.getItem("deptName");
      this.isManager = localStorage.getItem("isManager");
    },
    modifyPwPop() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.ModifyPassword.001","비밀번호 변경"),
        width: "500px",
        height: "574px",
        obj: this.$modal,
        component: ModifyPassword
      };
      this.showModal(modalInfo);
    },
    /* 로그아웃 처리 */
    async handleLogout() {
      if(location.host.indexOf("hanwhalife.com") > -1 && location.host != "cpdev.hanwhalife.com"){
        let ssoLogout = false;
        ssoLogout = await this.logoutSSOClearYN();
        if(ssoLogout){
          await this.logoutNeo();
          await this.logoutCowork();
        } else {
          return;
        }
      }
      else if (confirm(this.$i18nUtil.trans("message.logout","로그아웃 하시겠습니까?"))) {
        await this.logoutNeo();
        await this.logoutCowork();
      } else {
        return;
      }
    },
    logoutCowork() {
      let obj = this;
      let reqData = {
        url : "/api/auth/logout",
        method : "post",
        params : {
          loginType: 'WEB'
        }
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        alert(obj.$i18nUtil.trans("TG001"));
        localStorage.clear();
        if(location.host.indexOf("hanwhalife.com") > -1 && location.host != "cpdev.hanwhalife.com"){
          obj.$router.push("/hcpsso/sso_login");
        }
        else{
          obj.$router.push("/login");
          obj.setSocketDisConnect();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    logoutNeo() {
      let obj = this;
      let reqData = {
        url : "/neo/logout",
        method : "post"
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        // console.log("################");
        // console.log(res);
        // console.log("################");
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    // modifyNotiSetting() {
    //   const modalInfo = {
    //     title: "알림 변경",
    //     width: $(window).width(),
    //     height: $(window).height(), 
    //     obj: this.$modal,
    //     component: ModifyNotiSetting
    //   };
    //   this.showModal(modalInfo);
    //   this.show1 = false;
    // },
    resetUnifiedSearchKeyword() {
      let obj = this;
      obj.unifiedSearchKeyword = '';
    },
    openUnifiedSearch() {    
      let obj = this;
      if (obj.unifiedSearchKeyword == '') {
        obj.toastInfo.message = obj.$i18nUtil.trans("TB091");
        obj.showToast(obj.toastInfo);
        return;
      }
      let reqData = {};
      reqData.params = {
        cdCategory: 'config.sharepoint',
        cdKey: 'unifiedsearch.url'
      };
      reqData.req = this.req;
      reqData.method = "post";
      reqData.url = "/api/org/getCodeValueList";
      this.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
          let codeList = res.result;
          let url = codeList[0].cdValue;
          let value = obj.unifiedSearchKeyword;
          value = encodeURIComponent(value);
          //value = value.replaceAll("<", "&lt;");
          //value = value.replaceAll(">", "&gt;");
          url += "?k=" + value;
          url += "&pre=" + encodeURIComponent(btoa(localStorage.getItem("userId")));
          url += "&domain=" + encodeURIComponent(location.protocol + '//' + location.host);
          /**
            * 통합검색 시 언어 코드 값 추가.
            * 한국어 1042, 영어 1033로 넘겨줌
          **/
          let langset = localStorage.getItem("defaultLanguage").substring(0, 2);
          let langset_ = "1042";
          if (langset !== 'ko') {
            langset_ = '1033';
          }
          url += "&langcode=" + langset_;
          console.log(url);          
          window.open(url, "unifiedSearch", "width=1282, height=768, menubar=no, status=no, scrollbars=yes, resizable=yes, top=5");
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    checkUnifiedSearchUse() {    
      let obj = this;

      let reqData = {};
      reqData.params = {
        cdCategory: 'config.sharepoint',
        cdKey: 'unifiedsearch.use'
      };
      reqData.req = this.req;
      reqData.method = "post";
      reqData.url = "/api/org/getCodeValueList";
      this.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
          let codeList = res.result;
          if(codeList !=null){
            if(codeList[0].cdValue == "true"){
              obj.unifiedSearchUse = true;
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/cowork/general/main/MainHeader.vue